<svg width="32" height="29" xmlns="http://www.w3.org/2000/svg">
  <g [attr.stroke]="(colorName ? (colorName | color) : color)" fill="none" fill-rule="evenodd" stroke-linecap="round">
    <path stroke-linejoin="round" d="M28.375 9.063V4h-5.063M28.375 18.625v9h-9v-9h-6.75v9h-9V13L16 .625 30.625 15.25" />
    <path d="M3.625 13l-2.25 2.25" />
  </g>
</svg>
